import { FC } from 'react'
import { useAuth } from '../../context/auth-context'

import { useCollapse } from '../../routes/collapse-context'
import { RoleName } from '../../types'
import { CompanySettingsBUView } from './CompanySettingsBUView'
import { CompanySettingsManagerView } from './CompanySettingsManagerView'
import './index.less'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { ContentContainer } from '../../components/custom_components/ContentContainer'

const isOnlyBuManager = (userRoles: RoleName[] | undefined | null) => {
  const excludedRoles = [RoleName.ClusterManager, RoleName.NetworkManager, RoleName.CompanyManager, RoleName.BusinessPartner]

  if (!userRoles) {
    return false
  }

  return (
    userRoles.includes(RoleName.BuManager) && !userRoles.some((name: RoleName) => excludedRoles.includes(name) || name.startsWith('HR'))
  )
}

const isManager = (userRoles: RoleName[] | undefined | null) => {
  if (!userRoles || userRoles.length === 0) {
    return false
  }
  for (const role of [
    RoleName.BuManager,
    RoleName.BusinessPartner,
    RoleName.CompanyManager,
    RoleName.ClusterManager,
    RoleName.NetworkManager,
  ]) {
    if (userRoles.includes(role)) {
      return true
    }
  }
  return false
}

export const CompanySettingsView: FC = () => {
  const { user } = useAuth()
  const collapsed = useCollapse()

  if (!user.roles || user.roles.length === 0 || user.roles.includes(RoleName.Hr) || !isManager(user.roles)) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors isLoading={false} hasNoData={false} error={undefined} isPermissionDenied={true} />
      </ContentContainer>
    )
  } else {
    return isOnlyBuManager(user.roles) ? (
      <CompanySettingsBUView collapsed={collapsed} />
    ) : (
      <CompanySettingsManagerView collapsed={collapsed} />
    )
  }
}
